import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersRealtime, FiltersRealtimeState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersRealtimeState, RootState> = {
  updateFilters({ commit }, payload: FiltersRealtime): any {
    commit('onUpdateFilters', payload);
  },
};
